/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S6_Item3_PrefixInputs */

const tr_cerez_s6_item3_prefix = /** @type {(inputs: Cerez_S6_Item3_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desteklenen tarayıcı rehberleri:`)
};

const en_cerez_s6_item3_prefix = /** @type {(inputs: Cerez_S6_Item3_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guides for supported browsers:`)
};

const de_cerez_s6_item3_prefix = /** @type {(inputs: Cerez_S6_Item3_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leitfäden der unterstützten Browser:`)
};

const ru_cerez_s6_item3_prefix = /** @type {(inputs: Cerez_S6_Item3_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Руководства поддерживаемых браузеров:`)
};

/**
* | output |
* | --- |
* | "Guides for supported browsers:" |
*
* @param {Cerez_S6_Item3_PrefixInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s6_item3_prefix = /** @type {((inputs?: Cerez_S6_Item3_PrefixInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S6_Item3_PrefixInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s6_item3_prefix(inputs)
	if (locale === "de") return de_cerez_s6_item3_prefix(inputs)
	if (locale === "ru") return ru_cerez_s6_item3_prefix(inputs)
	return tr_cerez_s6_item3_prefix(inputs)
});